let ias = new InfiniteAjaxScroll('#product-grid', {
  item: '.grid__item.js__grid-item',
  next: '.next',
  pagination: '.pagination'
});


ias.on('load', function(event) {
	document.querySelector(".ajax__loader-container").style.display = "block"
});

ias.on('loaded', function(event) {
	document.querySelector(".ajax__loader-container").style.display = "none"
});

/*ias.on('page', (event) => {
  document.title = event.title;

  // update the url
  let state = history.state;
  history.replaceState(state, event.title, event.url);
})*/

